import { forwardRef } from 'react';

import { createChainedFunction } from 'utils';

import useCheckboxGroup from '../CheckboxGroup/CheckboxGroup.useContext';
import Check, { CheckProps } from '../Check';

import { CheckRoot, Root, Label } from './Checkbox.styles';

export type CheckboxProps = {
  label?: string;
} & CheckProps;

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      id,
      name: nameProp,
      disabled: disabledProp,
      required: requiredProp,
      readOnly: readOnlyProp,
      checked: checkedProp,
      defaultChecked,
      value,
      onChange: onChangeProp,
      inputProps = {},
      color: colorProp,
      ...props
    },
    ref,
  ) => {
    const checkboxGroup = useCheckboxGroup();

    const onChange = createChainedFunction(
      onChangeProp,
      checkboxGroup?.onChange,
    );

    let checked = checkedProp;
    let name = nameProp;
    let disabled = disabledProp;
    let readOnly = readOnlyProp;
    let required = requiredProp;
    let color = colorProp;

    if (checkboxGroup) {
      if (checked === undefined) {
        if (checkboxGroup && checkboxGroup.value) {
          checked = !!value && checkboxGroup.value === value;
        }
      }
      if (name === undefined) {
        name = checkboxGroup.name;
      }
      if (disabled === undefined) {
        disabled = checkboxGroup.disabled;
      }
      if (readOnly === undefined) {
        readOnly = checkboxGroup.readOnly;
      }
      if (required === undefined) {
        required = checkboxGroup.required;
      }
      if (color === undefined) {
        color = checkboxGroup.color;
      }
    }

    const radioProps = {
      id,
      name,
      value,
      defaultChecked,
      inputProps,
      checked,
      disabled,
      readOnly,
      onChange,
      required,
      ref,
      color,
    };

    const labelProps = {
      children: label,
    };

    return (
      <Root disabled={disabled || readOnly} {...props}>
        <CheckRoot>
          <Check {...radioProps} />
        </CheckRoot>
        <Label {...labelProps} />
      </Root>
    );
  },
);

export default Checkbox;
